mutation NoteTripCreate($input: NoteTripCreateInput!) {
  noteTripCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
